import { JoonUIColor, QuestDifficulty, Typography } from "@joonapp/web-shared"

import { capitalizeFirstLetter } from "../../../util/util"

type Props = {
  difficulty: QuestDifficulty
  reward: number | null
}

const DifficultyBadge = ({ difficulty, reward }: Props) => {
  const getBadgeColor = (difficulty: QuestDifficulty) => {
    switch (difficulty) {
      case "easy":
        return JoonUIColor.semantic.success
      case "medium":
        return JoonUIColor.semantic.warning
      case "hard":
        return JoonUIColor.semantic.destructive
    }
  }

  return (
    <div
      className="flex flex-row items-center justify-center rounded-md whitespace-nowrap w-fit h-fit px-3 py-1 gap-1"
      style={{ background: getBadgeColor(difficulty) }}
    >
      <Typography variant="bodyXSmall" color={JoonUIColor.text.inverted}>
        {capitalizeFirstLetter(difficulty)} {reward}
      </Typography>
      <img
        src="/images/icons/coin-icon.png"
        alt="coin"
        className="h-4 w-auto"
      />
    </div>
  )
}

export default DifficultyBadge
